<template>
  <div class="form-group d-flex text-md">
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="text-h6 text-center">
          {{ dialog_message }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="(dialog = false), (deldigit = false)"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="(dialog = false), specialButtonDel()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="w-25 mx-1">
      <span class="form-control text-success text-monospace px-1 text-center">
        {{ item.digits }}
      </span>
      <input required type="hidden" name="type" :value="item.type" />
    </div>
    <div class="w-25 mx-1">
      <div class="input-group-append input-group-joined">
        <input
          v-model="item.amount"
          required
          type="tel"
          name="amount"
          class="form-control text-monospace px-1 text-center text-black"
          @paste="onPaste($event)"
          @keypress="validateNumber($event)"
          :disabled="gameMasterSlug.startsWith('step_')"
        />
      </div>
    </div>

    <div class="w-50 d-flex">
      <span
        v-if="item.type != '4upper'"
        class="form-control text-success text-monospace px-1 text-center"
      >
        {{
          Intl.NumberFormat({ style: "currency", currency: "THB" }).format(
            item.amount * item.paybaht
          )
        }}
      </span>
      <span
        v-else
        class="form-control text-success text-monospace px-1 text-center"
      >
        1 ชุด
      </span>
      <span
        class="bg-primary px-2 text-white w-25 rounded-right d-flex align-items-center justify-content-center btn"
        @click="handleDelete($event)"
      >
        <i class="far fa-trash-alt" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BetList",
  props: {
    item: "",
    gameMasterSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog_message: "",
      dialog: false,
      delVal: "",
      rules: [(value) => !!value || "Required."],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleDelete(evn) {
      this.$set(this, "dialog", true);
      this.$set(this, "dialog_message", `ต้องการลบเลข ${this.item.digits}`);
      this.$set(this, "delVal", this.item.digits);
    },
    specialButtonDel() {
      this.$emit("item-delete", this.item);
    },
    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        if (charCode !== 46) {
          return true;
        }
        evt.preventDefault();
      }
    },
    onPaste(evt) {
      evt.preventDefault();
    },
  },
};
</script>
